// TODO: Remove this helper after GotoStage Release or use this to announce any upcoming releases.

import i18n from 'i18next';
import config from 'config';
import React from 'react';
import { Image } from 'react-bootstrap';

export function getNewContentPlatformData() {
    return (
        <div>
            <div className="learn-more__heading">New content platform</div>
            <p>The new and upcoming content platform by GoToWebinar (to be announced soon) will gather content from Channel pages and make it easily discoverable to viewers all over!
            This is an all-access hub for on-demand webinars for a variety of audiences.
            It is a great opportunity to generate more views and leads by increasing your content discoverability, analyzing audience reports,
            building relationships and brand awareness, sharing via social accounts, and more.</p><br />
            <Image className="learn-more__img" style={{width: '80%'}}src={`${config.assets.url}/images/coming-soon/home-page.png`} alt="img" responsive />
        </div>);
}

export function getOptimizeContentData() {
    return (
        <div>
            <div className="learn-more__heading">Optimize Your Content for Discoverability</div>
            <p>Learn how you can prep your content before the platform launches and get ready to reach new prospects!</p>
            <p>Sprucing up your content can help you increase your chances of having your recording discovered by more potential viewers.
            Below we have a few tips for making your content the best it can be so that it catches the eye of users browsing the new content platform!</p>
            <p>You can make these changes to all videos directly from the Channel page, or from a specific video page.</p>
            <ol>
                <li><strong>Thumbnail pictures:</strong> Use a thumbnail that describes your video well and makes it stand out!
                Add a thumbnail picture to your recording by selecting the More icon  and then Add thumbnail.
                If you were provided a default thumbnail by GoToWebinar, you can remove it and replace with a new one.</li>
                <li><strong>Categories:</strong> Categorized videos will appear higher in search results and recommended content.
                Categorize your recording by selecting the More icon and Add Category.
                There are many category options to choose from including Business, Fitness, Marketing, and more.</li>
                <li><strong>Video title:</strong> Use a catchy title. Edit a video title by hovering over the current title and then the Edit icon.</li>
                <li><strong>Video description:</strong> Video descriptions will help them appear higher in search results.
                Add a video description by selecting a specific video and then the "Add a brief description here" field.</li>
            </ol>
            <Image className="learn-more__img" src={`${config.assets.url}/images/coming-soon/channel-edit-video.png`} alt="img" responsive />
        </div>);
}

export function getLimitViewersData() {
    return (
        <div>
            <div className="learn-more__heading">Limit Your Channel Viewers</div>
            <p>Don&#039;t want your Channel page to be accessible to the general public?</p>
            <p>You can easily change this setting to allow only those with a direct link to your Channel or video to have access to your page.
            Changing this setting will prevent your videos from displaying on the new content platform.
            Note that this setting will be available starting October 30th, 2017.</p>
            <strong>Note:</strong> There is no option yet to limit access to specific videos only.<br /><br />
            <ul>
                <li>Go to the
                    <a href={`${config.broker.g2w.baseURL}/recordings.tmpl`} target="_blank"> {i18n.t('learnMore.addRecordings.instruction2b')} </a>
                     page or sign in directly from your Channel page with your GoToWebinar, LinkedIn, Facebook or Gmail account.
                </li>
                <li>Select <strong>View Channel Page</strong> to access your Channel.</li>
                <li>Select the Globe icon and Private in the drop-down menu.</li>
            </ul>
            <Image className="learn-more__img" style={{width: '80%'}}src={`${config.assets.url}/images/coming-soon/channel-private.png`} alt="img" responsive />
        </div>);
}



// WEBPACK FOOTER //
// ./src/app-lib/helpers/coming-soon-helper.js